import {
  membershipPauseToolDef,
  type MembershipPauseToolDef,
} from '@form-factory/schema/contracts';

import { MembershipPause } from './components/MembershipPause';
import { createToolComponent } from '../../../toolRegistry';
import { ToolNoDataError } from '../components/ToolNoDataError';

export const MembershipPauseTool = createToolComponent(
  {
    schema: {
      content: membershipPauseToolDef,
    },
  },
  ({ toolCall, state, content }) => {
    // Don't render during streaming
    if (state === 'call' || state === 'call-partial') {
      return null;
    }

    // Get data - ToolProvider already unwrapped it
    const data = state === 'result' && content ? content : toolCall.args;

    // Return early if we don't have data
    if (!data) {
      return null;
    }

    const args = data as MembershipPauseToolDef;

    if (!args.content && (state === 'call-complete' || state === 'result')) {
      return <ToolNoDataError />;
    }

    return <MembershipPause pause={{ ...args, content: args.content }} />;
  },
);
